/**
 * Per-tool confirmation card registry (plan 05 B3, 2026-09-29).
 *
 * Maps a card kind (from utils/confirmationRequest.js, keyed by the agent's
 * (tool, schema_version)) to its renderer. Adding a write tool means one
 * parser entry, one card here, and the regenerated vendored schema. Anything
 * that does not resolve to a registered kind renders as UnsupportedCard.
 */
import React from 'react';
import IncidentReportCard from './IncidentReportCard';
import UnsupportedCard from './UnsupportedCard';
import { resolveRenderCardKind } from '../../../utils/confirmationCards';
import {
  CARD_KIND_INCIDENT_REPORT,
  CARD_KIND_UNSUPPORTED,
} from '../../../utils/confirmationRequest';

export const CONFIRMATION_CARD_RENDERERS = Object.freeze({
  [CARD_KIND_INCIDENT_REPORT]: IncidentReportCard,
  [CARD_KIND_UNSUPPORTED]: UnsupportedCard,
});

/**
 * @param {object} props
 * @param {object} props.message - A `{type: 'confirmation', ...}` chat message.
 * @param {boolean} props.isLoading
 * @param {(confirmationId: string) => void} props.onConfirm
 */
export default function ConfirmationCardView({ message, isLoading, onConfirm }) {
  const kind = resolveRenderCardKind(message);
  const Card = (Object.prototype.hasOwnProperty.call(CONFIRMATION_CARD_RENDERERS, kind)
    && CONFIRMATION_CARD_RENDERERS[kind]) || UnsupportedCard;
  return <Card message={message} isLoading={isLoading} onConfirm={onConfirm} />;
}
